import React from 'react'

import BasicRoute from 'components/routes/BasicRoute'

import FrenteConsulta from 'entity/Frente/components/FrenteConsulta'
import FrenteForm from 'entity/Frente/components/FrenteForm'

export default function RoutesMenusFrente() {
    return (
        <>
            <BasicRoute
                perfilAuth={['r9jrEQXznNgjrZTGCfch', 'RECT03jkyTQW9B2OMz47']}//admin ou tecnico
                uid="consulta-frente"
                route="consulta-frente"

                menuProps={{
                    text: "Frentes",
                    sequence: "111117",
                    iconName: "Workspaces",

                    parent: {
                        uid: "parentCadastros",
                        text: "Cadastros",
                        sequence: "222222",
                        iconName: 'Edit'
                    }
                }}

                element={<FrenteConsulta />}
            />
            <BasicRoute
                uid="frente"
                route="_frente"
                element={<FrenteForm />}
            />
        </>
    )
}
